'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFormSubmitSagaTo = exports.formSubmitSaga = exports.onSubmitActions = exports.SUFFIX = undefined;

var _common = require('./common');

Object.defineProperty(exports, 'SUFFIX', {
  enumerable: true,
  get: function get() {
    return _common.SUFFIX;
  }
});

var _reduxForm = require('redux-form');

var _create2 = require('./create');

var _create3 = _interopRequireDefault(_create2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _create = (0, _create3.default)(_reduxForm.SubmissionError);

var onSubmitActions = _create.onSubmitActions;
var formSubmitSaga = _create.formSubmitSaga;
var addFormSubmitSagaTo = _create.addFormSubmitSagaTo;
exports.onSubmitActions = onSubmitActions;
exports.formSubmitSaga = formSubmitSaga;
exports.addFormSubmitSagaTo = addFormSubmitSagaTo;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form-submit-saga/lib/index.js
// module id = 438
// module chunks = 1